import { sessaoFetch } from '@/service/fetch'

export async function list () {
  return sessaoFetch(`base`, `/banco?all=1`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/banco.js